import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntelligenceReportingRoutingModule } from './intelligence-reporting-routing.module';
import { QuestionCategoriesFilterComponent } from './components/question-categories/question-categories-filter/question-categories-filter.component';
import { QuestionCategoriesTableComponent } from './components/question-categories/question-categories-table/question-categories-table.component';
import { EditQuestionCategoriesComponent } from './components/question-categories/edit-question-categories/edit-question-categories.component';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {QuestionsComponent} from './containers/questions/questions.component';
import {QuestionCategoriesComponent} from './containers/question-categories/question-categories.component';
import { QuestionsTableComponent } from './components/questions/questions-table/questions-table.component';
import { QuestionsFilterComponent } from './components/questions/questions-filter/questions-filter.component';
import { EditQuestionsComponent } from './components/questions/edit-questions/edit-questions.component';
import { CreateQuestionsComponent } from './components/questions/create-questions/create-questions.component';
import { RoundOfQuestionsComponent } from './containers/round-of-questions/round-of-questions.component';
import { RoundOfQuestionsFilterComponent } from './components/round-of-questions/round-of-questions-filter/round-of-questions-filter.component';
// tslint:disable-next-line:max-line-length
import { RoundOfQuestionsTableComponent } from './components/round-of-questions/round-of-questions-table/round-of-questions-table.component';
import { CreateRoundOfQuestionsComponent } from './components/round-of-questions/create-round-of-questions/create-round-of-questions.component';
import { EditRoundOfQuestionsComponent } from './components/round-of-questions/edit-round-of-questions/edit-round-of-questions.component';
import { LaunchRoundOfQuestionsComponent } from './components/round-of-questions/launch-round-of-questions/launch-round-of-questions.component';
import { FormsComponent } from './containers/forms/forms.component';
import { FormsFilterComponent } from './components/forms/forms-filter/forms-filter.component';
import { FormsTableComponent } from './components/forms/forms-table/forms-table.component';
import { EditFormsAdminComponent } from './components/forms/edit-forms/edit-forms-admin.component';
import { UploadFormsComponent } from './components/forms/upload-forms/upload-forms.component';
import {NgxMatFileInputModule} from '@angular-material-components/file-input';
import { CreateQuestionCategoriesComponent } from './components/question-categories/create-question-categories/create-question-categories.component';


@NgModule({
  declarations: [
    QuestionsComponent,
    QuestionCategoriesComponent,
    QuestionCategoriesFilterComponent,
    QuestionCategoriesTableComponent,
    EditQuestionCategoriesComponent,
    QuestionsTableComponent,
    QuestionsFilterComponent,
    EditQuestionsComponent,
    CreateQuestionsComponent,
    RoundOfQuestionsComponent,
    RoundOfQuestionsFilterComponent,
    RoundOfQuestionsTableComponent,
    CreateRoundOfQuestionsComponent,
    EditRoundOfQuestionsComponent,
    LaunchRoundOfQuestionsComponent,
    FormsComponent,
    FormsFilterComponent,
    FormsTableComponent,
    EditFormsAdminComponent,
    UploadFormsComponent,
    CreateQuestionCategoriesComponent
  ],
  exports: [
    QuestionCategoriesFilterComponent,
    QuestionCategoriesTableComponent
  ],
    imports: [
        CommonModule,
        IntelligenceReportingRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        NgxMatFileInputModule,
    ]
})
export class IntelligenceReportingModule { }
